import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI';
import { format } from 'date-fns';

export interface VoiceCallStatusLogs {
  callSid: string;
  status: string;
  from: string;
  to: string;
  duration: number;
  timestamp: string;
  sequenceNumber: number;
  called: string;
  durationInMin: string;
  direction: string;
  accountSid: string;
  callbackSource: string;
  applicationSid: string;
}

interface VoiceCallStatusLogsProps {
  open: boolean;
  onClose: () => void;
  statusLogs: VoiceCallStatusLogs[]
}

const columns = () =>  [
  {
    field: 'from',
    headerName: 'From',
    sortable: false
  },
  {
    field: 'to',
    headerName: 'To',
    sortable: false
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false
  },
  {
    field: 'direction',
    headerName: 'Direction',
    sortable: false
  },
  {
    field: 'durationInMin',
    headerName: 'Duration',
    sortable: true,
    valueFormatter: ({ value }) => `${value} mins`
  },
  {
    field: 'timestamp',
    headerName: 'Timestamp',
    sortable: false,
    valueFormatter: ({ value }) =>
      value ? format(new Date(value), 'dd MMM yyyy HH:mm') : ''
  },
]

const VoiceCallStatusLogsDialog: React.FC<VoiceCallStatusLogsProps> = ({ open, onClose, statusLogs }) => {
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth
      PaperProps={{
        style: {
          width: '80%', 
          maxWidth: 'none',
          padding: '10px'
        }
      }}
    >
      <DialogTitle>Voice Call Status Logs</DialogTitle>
      <Divider />
      <DialogContent>
        <MUIDataGrid
          getRowId={(row) => `${row.Timestamp}-${row.callSid}`}
          columns={columns()}
          rows={statusLogs ?? []}
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-iconSeparator': {
              visibility: 'hidden'
            },
            '& .MuiDataGrid-footerContainer': {
              border: '0'
            },
            '& .MuiDataGrid-cell': {
              border: '0px'
            },
            '& .MuiDataGrid-columnHeaders': {
              border: '1',
              borderColor: 'black'
            },
            '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
              outline: 'none'
            },
            mx: '-10px'
          }}
        />
      </DialogContent>
      <DialogActions style={{ margin: '-10px 12px 10px 0' }}>
        <Button onClick={onClose} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoiceCallStatusLogsDialog;
